import { Language } from "@/services/global-services/models";
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";

type DownloadLanguagesDropdownProps = {
    items: Array<Language>;
    value: string;
    onChange: (event: SelectChangeEvent<string>) => void;
};

const DownloadLanguagesDropdown = ({ items, value, onChange }: DownloadLanguagesDropdownProps) => {
    return (
        <FormControl fullWidth size={"medium"} id={"medium"}>
            <InputLabel id="language-dropdown-label">Language</InputLabel>
            <Select
                labelId="language-dropdown-label"
                id="language-dropdown"
                value={value}
                onChange={onChange}
                input={<OutlinedInput label={"Language"} />}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 4.5 + 8,
                        },
                    },
                }}
                fullWidth
            >
                {items.map((language, index) => (
                    <MenuItem key={index} value={language.slug}>
                        {language.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default DownloadLanguagesDropdown;
